import { render, staticRenderFns } from "./bulk-creation-inputs.vue?vue&type=template&id=16355d17&scoped=true&"
import script from "./bulk-creation-inputs.vue?vue&type=script&lang=js&"
export * from "./bulk-creation-inputs.vue?vue&type=script&lang=js&"
import style0 from "./bulk-creation-inputs.vue?vue&type=style&index=0&id=16355d17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16355d17",
  null
  
)

export default component.exports